// Small in-browser image helpers: load a chosen photo, crop it to a fixed frame and re-encode it as a small JPEG
// (so uploads are tiny and the server only has to check the shape).
export function loadImage(file) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const url = URL.createObjectURL(file);
    img.onload = () => { URL.revokeObjectURL(url); resolve(img); };
    img.onerror = () => { URL.revokeObjectURL(url); reject(new Error("That file isn't a picture we can read.")); };
    img.src = url;
  });
}

// Draw `img` into an outW x outH frame ("cover"), zoomed and shifted. offsetX/offsetY are -1..1 across the spare room.
export function cropToDataUrl(img, { outW, outH, zoom = 1, offsetX = 0, offsetY = 0, maxChars = 200000 }) {
  const canvas = document.createElement("canvas");
  canvas.width = outW; canvas.height = outH;
  const ctx = canvas.getContext("2d");
  const scale = Math.max(outW / img.naturalWidth, outH / img.naturalHeight) * zoom;
  const dw = img.naturalWidth * scale; const dh = img.naturalHeight * scale;
  const x = (outW - dw) / 2 + offsetX * ((dw - outW) / 2);
  const y = (outH - dh) / 2 + offsetY * ((dh - outH) / 2);
  ctx.fillStyle = "#ffffff"; ctx.fillRect(0, 0, outW, outH);
  ctx.drawImage(img, x, y, dw, dh);
  let q = 0.85; let url = canvas.toDataURL("image/jpeg", q);
  while (url.length > maxChars && q > 0.35) { q -= 0.1; url = canvas.toDataURL("image/jpeg", q); }
  return url;
}

export async function fileToSquare(file, size = 480, maxChars = 200000) {
  const img = await loadImage(file);
  return cropToDataUrl(img, { outW: size, outH: size, maxChars });
}
